export const HIDE_AGE_RESTRICTION = 'HIDE_AGE_RESTRICTION';
export const SHOW_AGE_RESTRICTION = 'SHOW_AGE_RESTRICTION';
export const UPDATE_AGE_RESTRICTION = 'UPDATE_AGE_RESTRICTION';
